import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart({
      content_name: 'Panadería sin Culpa - Ebook',
      content_ids: ['53390925005133'],
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
    // Redirect to purchase page
    window.location.href = 'https://www.consejossimples.com/cart/53390925005133:1';
  };
  const includes = ['El ebook completo Panadería sin Culpa', 'El Método de Leudado Biológico explicado paso a paso', 'Tablas y guías para adaptar recetas', 'Ejemplos concretos para que no tengas que improvisar', 'Acceso inmediato y para siempre'];
  return <section id="offer-section" ref={ref} className="w-full bg-cream px-4 py-16 md:py-24" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-52">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-53">
            Tu Inversión
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border-4 border-terracotta relative overflow-hidden" data-id="element-54">
          <div className="absolute top-6 right-6 bg-terracotta text-white px-4 py-2 rounded-full font-body font-bold text-sm shadow-lg" data-id="element-55">
            65% OFF
          </div>

          <div className="text-center mb-8" data-id="element-56">
            <p className="font-body text-lg text-brown/60 mb-2" data-id="element-57">Por solo</p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
              <span className="font-heading text-2xl md:text-3xl font-bold text-brown/40 line-through" data-id="element-59">
                $31.140
              </span>
              <span className="font-body text-lg text-brown/40 line-through" data-id="element-60">
                ARS
              </span>
            </div>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-61">
              <span className="font-heading text-5xl md:text-6xl font-bold text-terracotta" data-id="element-62">
                $11.000
              </span>
              <span className="font-body text-2xl text-brown/60" data-id="element-63">ARS</span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-64">
              <span className="font-body text-base text-brown/40 line-through" data-id="element-65">
                $18 USD
              </span>
              <span className="font-body text-lg font-semibold text-terracotta" data-id="element-66">
                → $6.36 USD
              </span>
            </div>
          </div>

          <div className="space-y-4 mb-10" data-id="element-67">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: 0.4 + index * 0.1
          }} className="flex items-start gap-4" data-id="element-68">
                <CheckCircleIcon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-69" />
                <p className="font-body text-base md:text-lg text-brown" data-id="element-70">
                  {item}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.8,
          delay: 0.9
        }} className="text-center" data-id="element-71">
            <Button size="lg" onClick={handlePurchase} className="w-full sm:w-auto text-xl" data-id="element-72">
              Sí, Quiero Panadería sin Culpa
            </Button>
            <p className="font-body text-sm text-brown/60 mt-4" data-id="element-73">
              Acceso inmediato después del pago
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8,
        delay: 1.1
      }} className="mt-12 text-center" data-id="element-74">
          <p className="font-body text-lg text-brown/80 italic" data-id="element-75">
            "La diferencia no es que 'yo cocino lindo'. La diferencia es que te
            enseño qué mirar en la masa, qué corregir cuando algo falla, y cómo
            repetir resultados."
          </p>
        </motion.div>
      </div>
    </section>;
}